<template>
  <div />
</template>

<script>
import $ from 'jquery'
import Store from 'store'
import { is_touchable_device } from '@/utils.js'

export default {
  props: {
    storageId: {
      type: String,
      required: true,
    },
    hideForUser: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['fire'],
  data() {
    return {
      timer: null,
    }
  },
  mounted() {
    if (is_touchable_device()) {
      return
    }
    if (this.hideForUser && Spark.state.user) {
      return
    }
    Store.remove(this.storageId)
    this.timer = setTimeout(() => {
      $(document).mouseout((e) => {
        const vpWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        if (e.clientX >= (vpWidth - 50) || e.clientY >= 50) {
          return
        }

        const from = e.relatedTarget || e.toElement
        const isIframe = window.parent !== window
        if ((!from || isIframe) && !Store.get(this.storageId)) {
          Store.set(this.storageId, '1')
          this.$emit('fire')
        }
      })
    }, 5000)
  },
  beforeUnmount() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  },
}
</script>

<style>

</style>
